import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

/**
 * Component to protect routes that require specific roles
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authorized
 * @param {Array} props.allowedRoles - Array of roles that are allowed to access this route
 */
const RoleBasedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, loading, user } = useContext(AuthContext);
  
  // If still loading, don't redirect yet
  if (loading) {
    return <div>Loading...</div>;
  }
  
  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  // If no roles specified or empty array, just check authentication
  if (!allowedRoles || allowedRoles.length === 0) {
    return children;
  }
  
  // Check if user has one of the allowed roles
  const userRole = user?.role?.toLowerCase();
  if (userRole && allowedRoles.map(role => role.toLowerCase()).includes(userRole)) {
    return children;
  }
  
  // If user doesn't have the required role, redirect to unauthorized page or dashboard
  return <Navigate to="/unauthorized" />;
};

export default RoleBasedRoute;
